/**
 * 사용자에게 노출할 에러 문구 정책.
 *
 * - 정의된 도메인 에러(HTTP 4xx + 서버 message)는 그대로 노출한다. (예: "이미 가입된 이메일입니다.")
 * - 그 외(5xx/네트워크/미정의 에러)는 원문(스택·트랜잭션 메시지 등)을 노출하지 않고
 *   일반 문구로 대체한다. → 서버 내부 에러가 사용자에게 그대로 새는 것을 방지.
 */

export const UNKNOWN_ERROR_MESSAGE = '알 수 없는 에러입니다. 관리자에게 문의해주세요.';

interface HttpErrorLike {
  response?: {
    status?: number;
    data?: { message?: string };
  };
}

/**
 * 에러 객체로부터 사용자에게 보여줄 안전한 문구를 반환한다.
 * 4xx + 서버 message가 있으면 그 message, 아니면 [UNKNOWN_ERROR_MESSAGE].
 */
export function getUserFacingErrorMessage(error: unknown): string {
  const err = error as HttpErrorLike | undefined;
  const status = err?.response?.status;
  const raw = err?.response?.data?.message;
  const message = typeof raw === 'string' ? raw.trim() : '';

  if (status && status >= 400 && status < 500 && message) {
    return message;
  }
  return UNKNOWN_ERROR_MESSAGE;
}
